<template>
  <div class="section">
    <!-- 测试者状态测验个人分析报告【报告导读心理、人格、团队】 -->
    <img :src="images.back" style="height: auto; width: 38%" />
    <div style="margin-top: -450px; margin-left: 130px">
      <img :src="images.title" style="height: auto; width: 50%" />
    </div>
    <img
      :src="images.logo"
      style="
        height: auto;
        width: 14%;
        float: right;
        margin-top: -60px;
        margin-right: 50px;
      "
    />
    <!------ 心理报告导读文字 ------------------------------------------------------------------>
    <div v-if="isPsychology == true">
      <div class="content1">
        <i
          class="iconfont icon-yinhao"
          style="font-size: 40px; color: #d0d0d0"
        ></i>
        <p style="text-indent: 34px; letter-spacing: 1px; line-height: 25px">
          {{ content1 }}
        </p>
      </div>
      <div class="content2">
        <p style="text-indent: 34px; letter-spacing: 1px; line-height: 25px">
          {{ content2 }}
        </p>
      </div>
      <div class="content3-box">
        <div class="content3">
          <div v-html="content3"></div>
        </div>
        <div class="content4">
          <i
            class="iconfont icon-jiankang"
            style="font-size: 40px; color: #29bcb9"
          ></i>
          <p
            style="
              font-size: 20px;
              color: #29bcb9;
              font-weight: bold;
              margin-top: -35px;
              margin-left: 40px;
            "
          >
            健康的情绪
          </p>
          <p
            style="
              letter-spacing: 1px;
              line-height: 25px;
              margin-left: 40px;
              margin-top: 10px;
            "
          >
            {{ content4 }}
          </p>
        </div>
        <div class="content4">
          <i
            class="iconfont icon-hexie"
            style="font-size: 40px; color: #29bcb9"
          ></i>
          <p
            style="
              font-size: 20px;
              color: #29bcb9;
              font-weight: bold;
              margin-top: -35px;
              margin-left: 40px;
            "
          >
            和谐的人际关系
          </p>

          <p
            style="
              letter-spacing: 1px;
              line-height: 25px;
              margin-left: 40px;
              margin-top: 10px;
            "
          >
            {{ content5 }}
          </p>
        </div>
        <div class="content4" style="padding-bottom: 30px">
          <i
            class="iconfont icon-wanzheng"
            style="font-size: 40px; color: #29bcb9"
          ></i>
          <p
            style="
              font-size: 20px;
              color: #29bcb9;
              font-weight: bold;
              margin-top: -35px;
              margin-left: 40px;
            "
          >
            完整统一的人格
          </p>

          <p
            style="
              letter-spacing: 1px;
              line-height: 25px;
              margin-left: 40px;
              margin-top: 10px;
            "
          >
            {{ content6 }}
          </p>
        </div>
      </div>
      <div class="content7">
        <p style="text-indent: 30px; letter-spacing: 1px; line-height: 25px">
          {{ content7 }}
        </p>
      </div>
    </div>
    <!------ 人格报告导读文字 ------------------------------------------------------------------>
    <div v-if="isPersonality == true">
      <div class="content1">
        <i
          class="iconfont icon-yinhao"
          style="font-size: 40px; color: #d0d0d0"
        ></i>

        <div style="text-indent: 34px; letter-spacing: 1px; line-height: 25px">
          {{ content1Per }}
          <p style="margin-top: 20px">{{ content2Per }}</p>
        </div>
      </div>
      <div class="content3Per-box">
        <div class="content3">
          <p
            style="
              letter-spacing: 1px;
              line-height: 25px;
              margin-left: 40px;
              margin-top: 10px;
            "
          >
            <i
              class="iconfont icon-jiankang"
              style="font-size: 30px; color: #29bcb9"
            ></i>
            {{ content3Per }}
          </p>
        </div>
        <div class="content3">
          <p
            style="
              letter-spacing: 1px;
              line-height: 25px;
              margin-left: 40px;
              margin-top: 10px;
            "
          >
            <i
              class="iconfont icon-hexie"
              style="font-size: 30px; color: #29bcb9"
            ></i>
            {{ content4Per }}
          </p>
        </div>
        <div class="content4">
          <p
            style="
              letter-spacing: 1px;
              line-height: 25px;
              margin-left: 40px;
              margin-top: 10px;
            "
          >
            <i
              class="iconfont icon-wanzheng"
              style="font-size: 30px; color: #29bcb9"
            ></i>
            {{ content5Per }}
          </p>
        </div>
        <div class="content4" style="padding-bottom: 30px"></div>
      </div>
      <div class="content7Per">
        <p style="text-indent: 34px; letter-spacing: 1px; line-height: 25px">
          {{ content6Per }}
        </p>
      </div>

      <div class="content7Per">
        <p style="text-indent: 34px; letter-spacing: 1px; line-height: 25px">
          {{ content7Per }}
        </p>
      </div>
    </div>
    <!------ 团队报告导读文字 ------------------------------------------------------------------>
    <div v-if="isTeam == true">
      <div class="content1">
        <i
          class="iconfont icon-yinhao"
          style="font-size: 40px; color: #d0d0d0"
        ></i>

        <div style="text-indent: 34px; letter-spacing: 1px; line-height: 25px">
          {{ content1Team }}
          <p style="margin-top: 20px">{{ content11Team }}</p>
        </div>
      </div>
      <div class="content3Per-box">
        <div class="content3">
          <p
            style="
              letter-spacing: 1px;
              line-height: 25px;
              margin-left: 40px;
              margin-top: 10px;
            "
          >
            <i
              class="iconfont icon-jiankang"
              style="font-size: 30px; color: #29bcb9"
            ></i>
            {{ content2Team }}
          </p>
        </div>
        <div class="content3" style="padding-bottom: 50px">
          <p
            style="
              letter-spacing: 1px;
              line-height: 25px;
              margin-left: 40px;
              margin-top: 10px;
            "
          >
            <i
              class="iconfont icon-hexie"
              style="font-size: 30px; color: #29bcb9"
            ></i>
            {{ content3Team }}
          </p>
        </div>
      </div>

      <div class="content7Per">
        <p style="text-indent: 34px; letter-spacing: 1px; line-height: 25px">
          {{ content4Team }}
        </p>
      </div>
    </div>
    <!------ 潜力行为报告导读文字 ------------------------------------------------------------------>
    <div v-if="isBehavior == true">
      <div class="content1">
        <i
          class="iconfont icon-yinhao"
          style="font-size: 40px; color: #d0d0d0"
        ></i>
        <p style="text-indent: 34px; letter-spacing: 1px; line-height: 25px">
          {{ content1Be }}
        </p>
      </div>
      <div class="content2">
        <p style="text-indent: 34px; letter-spacing: 1px; line-height: 25px">
          本次重点考察人才的"{{ this.behaviorResult.name }}",包括
          <span v-for="(items, index) in behaviorResult.level2" :key="index">
            <span v-if="index != behaviorResult.level2.length - 1">
              "{{ items.name }}"、
            </span>
            <span v-else> "{{ items.name }}" </span>
          </span>
          维度。
        </p>
      </div>
      <div class="content3-box">
        <div class="content3" style="margin-top: -10px">
          <div style="margin-top: 10px">
            大量的相关研究表明，测试者需要通过以下考察方向来判定：
          </div>
        </div>
        <div
          class="content4Be"
          v-for="(items, index) in behaviorResult.level2"
          :key="index"
        >
          <!-- <i
            class="iconfont icon-jiankang"
            style="font-size: 40px; color: #29bcb9"
          ></i> -->
          <p
            style="
              font-size: 20px;
              color: #29bcb9;
              font-weight: bold;
              margin-top: 8px;
              margin-left: 35px;
            "
          >
            {{ items.name }}
          </p>
          <br />
          <p
            style="
              letter-spacing: 1px;
              line-height: 25px;
              margin-left: 35px;
              margin-top: -20px;
            "
          >
            {{ items.define }}
          </p>
        </div>

        <!--         
        <div class="content4">
          <i
            class="iconfont icon-hexie"
            style="font-size: 40px; color: #29bcb9"
          ></i>
          <p
            style="
              font-size: 20px;
              color: #29bcb9;
              font-weight: bold;
              margin-top: -35px;
              margin-left: 40px;
            "
          >
            和谐的人际关系
          </p>

          <p
            style="
              letter-spacing: 1px;
              line-height: 25px;
              margin-left: 40px;
              margin-top: 10px;
            "
          >
            {{ content5 }}
          </p>
        </div>
        <div class="content4" style="padding-bottom: 30px">
          <i
            class="iconfont icon-wanzheng"
            style="font-size: 40px; color: #29bcb9"
          ></i>
          <p
            style="
              font-size: 20px;
              color: #29bcb9;
              font-weight: bold;
              margin-top: -35px;
              margin-left: 40px;
            "
          >
            完整统一的人格
          </p>

          <p
            style="
              letter-spacing: 1px;
              line-height: 25px;
              margin-left: 40px;
              margin-top: 10px;
            "
          >
            {{ content6 }}
          </p>
        </div> -->
      </div>
      <div class="content7" style="margin-top: -10px">
        <p style="text-indent: 30px; letter-spacing: 1px; line-height: 25px">
          {{ content2Be }}
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import {
  reportIntroduction,
  reportIntroductionPer,
  reportIntroductionTeam,
  reportIntroductionBehavior,
} from "@/views/report/config/three";

export default {
  props: [
    "isPersonality",
    "isPsychology",
    "isTeam",
    "isBehavior",
    "behaviorResult",
  ],
  data() {
    return {
      images: {
        logo: require("../../../assets/images/page1/logo.png"),
        back: require("../../../assets/images/page2/back.png"),
        title: require("../../../assets/images/page2/title.png"),
        page: require("../../../assets/images/page2/page.png"),
      },
      //心理
      content1: reportIntroduction.content1,
      content2: reportIntroduction.content2,
      content3: reportIntroduction.content3,
      content4: reportIntroduction.content4,
      content5: reportIntroduction.content5,
      content6: reportIntroduction.content6,
      content7: reportIntroduction.content7,
      //人格
      content1Per: reportIntroductionPer.content1,
      content2Per: reportIntroductionPer.content2,
      content3Per: reportIntroductionPer.content3,
      content4Per: reportIntroductionPer.content4,
      content5Per: reportIntroductionPer.content5,
      content6Per: reportIntroductionPer.content6,
      content7Per: reportIntroductionPer.content7,
      //团队
      content1Team: reportIntroductionTeam.content1,
      content11Team: reportIntroductionTeam.content11,
      content2Team: reportIntroductionTeam.content2,
      content3Team: reportIntroductionTeam.content3,
      content4Team: reportIntroductionTeam.content4,

      //潜力行为
      content1Be: reportIntroductionBehavior.content1,
      content2Be: reportIntroductionBehavior.content2,
    };
  },
};
</script>

<style lang="scss" scoped>
.section {
  page-break-before: always;
  page-break-after: always;
  page-break-inside: avoid;
  height: 1124px; //A4纸的高度像素
  overflow: hidden;
  .content1 {
    padding: 20px 50px 0 250px;
  }
  .content2 {
    padding: 20px 50px 20px 250px;
  }
  .content2Per {
    padding: 20px 50px 20px 150px;
  }
  .content3-box {
    background-color: #f5f6fa;
    margin-top: 10px;
  }
  .content3Per-box {
    background-color: #f5f6fa;
    margin-top: 40px;
  }
  .content3 {
    padding-left: 100px;
    padding-right: 40px;
    padding-top: 40px;
  }
  .content4 {
    padding-left: 100px;
    padding-right: 40px;
    padding-top: 20px;
  }
  .content4Be {
    padding-left: 60px;
    padding-right: 40px;
    padding-top: 1px;
  }

  .content7 {
    padding-left: 50px;
    padding-right: 40px;
    padding-top: 30px;
  }
  .content7Per {
    padding-left: 50px;
    padding-right: 40px;
    padding-top: 50px;
  }
  .page-info {
    width: 40px;
    height: 40px;
    text-align: center;
    line-height: 45px; /*让div中的文字内容垂直居中*/
    color: white;
    margin-left: 380px;
    background-color: #29bcb9;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/report/three/pageTwo.vue